export enum ProgramTabs {
  Overview = 'overview',
  Reporting = 'reporting',
}
